<template>
    <div class="addArticle">
        <HandMenu/>
        <el-card shadow="never" style="border: 0;border-right: 1px solid #EBEEF5;">
            <el-row :gutter="20">
                <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                </el-breadcrumb>
            </el-row>
            <el-card shadow="always" style="border: 0;border-right: 1px solid #EBEEF4;" v-loading="loading">
                <div style="padding: 5px;">
                    <el-input
                            type="text"
                            placeholder="请输入活动标题"
                            v-model="titleContent"
                            maxlength="200"
                            show-word-limit
                    >
                        <template slot="prepend">活动标题</template>
                    </el-input>
                    <!--选择文章类型-->
                    <div style="margin-top: 20px">
                        <el-divider content-position="left">选择活动时间</el-divider>
                        <!--时间选择器-->
                        <div class="block">
                            <el-date-picker
                                    v-model="time"
                                    type="datetime"
                                    placeholder="选择活动日期以及具体时间" style="width: 100%">
                            </el-date-picker>
                        </div>
                    </div>
                    <div style="margin-top: 20px">
                        <el-divider content-position="left">封面图片</el-divider>
                        <!--选择图片的组件-->
                        <CheckImageFile ref="inputFile" :visibleState="true"/>
                    </div>
                    <div style="margin-top: 20px">
                        <el-divider content-position="left">活动计划</el-divider>
                    </div>
                    <div>
                        <quillEditor STYLE="margin-top:20px;height: 500px;margin-bottom: 50px " v-model="bodyContent"
                                     ref="myQuillEditor"
                                     :options="editorOption"
                        />
                    </div>
                    <div style="float: right;margin-top: 10px;margin-bottom: 10px;">
                        <el-button type="primary" @click="addNewArticle" plain>提交活动</el-button>
                    </div>
                </div>
            </el-card>
        </el-card>
    </div>
</template>

<script>
    import {quillEditor} from "vue-quill-editor"; //调用编辑器
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import CheckImageFile from "../../components/CheckImageFile";
    import Vue from "../../main"
    import axios from "../../api/index"

    export default {
        name: "AddArticle",
        data() {
            return {
                //加载
                loading: false,
                //标题
                titleContent: "",
                //富文本编辑器内容
                bodyContent: "",
                //富文本编辑器配置
                editorOption: {
                    placeholder: '请输入活动计划...',
                },
                //选择的活动时间
                time: ""
            }
        },
        components: {
            quillEditor,
            CheckImageFile
        },
        methods: {
            addNewArticle() {
                let self = this;
                //获取所需的内容
                let title = this.titleContent;
                let content = this.bodyContent;
                let time = this.time;
                //获取组件中的文件
                let image = this.$refs.inputFile.returnImageFile();
                if (title == null || title.replace(/\s*/g, "") === "") {
                    Vue.$message({
                        message: "请输入活动标题！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                if (time == null || time === "") {
                    Vue.$message({
                        message: "请选择活动时间！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                if (image == null) {
                    Vue.$message({
                        message: "请选择要上传的图片！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                if (content == null || content.replace(/\s*/g, "") === "") {
                    Vue.$message({
                        message: "活动计划不能为空！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }
                let formData = new FormData();
                formData.append("title",title);
                formData.append("content",content);
                formData.append("time",time);
                formData.append("file",image);
                //进行内容添加
                axios.addNewArticle(formData).then(res => {
                    if (res.data==="success"){
                        Vue.$message({
                            message: "添加成功!",
                            duration: 2000,
                            type: "success"
                        });
                        //把内容清空
                        self.titleContent = "";
                        self.bodyContent = "";
                        self.time = "";
                        self.$refs.inputFile.clearImageInput();
                    }else{
                        Vue.$message({
                            message: res.data,
                            duration: 2000,
                            type: "error"
                        });
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .addArticle {
        flex: 1;
        overflow: auto;
        width: 100%;
        border: 0;
    }

</style>
